export enum StatUsersType {
  ActiveUsers = 'active-users',
  NewUsers = 'new-users',
  IPDUsers = 'ipd-users',
  Ltv = 'ltv',
}
